import { CheckCircle, Heart } from "lucide-react";
import { useSelector } from "react-redux";

export const About = () => {
  const company = useSelector((state) => state.company);

  return (
    <section id="tentang" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Tentang Kami
          </h2>
          <div className="w-24 h-1 bg-pink-600 mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-12">
          <div className="order-2 md:order-1">
            <p className="text-lg text-gray-700 text-justify mb-6 leading-relaxed">
              {company.description}
            </p>
            <div className="space-y-6">
              <div className="flex items-start">
                <Heart className="h-6 w-6 text-pink-600 mr-3 mt-1 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">
                    Visi Kami
                  </h3>
                  <p className="text-gray-600 text-justify">{company.vision}</p>
                </div>
              </div>
              <div className="flex items-start">
                <CheckCircle className="h-6 w-6 text-pink-600 mr-3 mt-1 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">
                    Misi Kami
                  </h3>
                  <p className="text-gray-600 text-justify">
                    {company.mission}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="order-1 md:order-2">
            <img
              src="pic1.jpg"
              alt="Rajutan Sari Asa"
              className="rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
